import axios from 'axios';

// Güvenli SaaS Mimarisi: Masaüstü uygulaması yerel backend yerine her zaman bulut sunucuya bağlanır.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://lumiere-backend-svoe.onrender.com';
export const API = `${BACKEND_URL}/api`;

export const getAuthToken = () => {
  return localStorage.getItem('admin_token') || sessionStorage.getItem('admin_token');
};

export const clearAuthToken = () => {
  localStorage.removeItem('admin_token');
  sessionStorage.removeItem('admin_token');
};

export const getAuthHeader = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Alert specific network errors so we can debug exactly what URL failed and why
    if (error.message === 'Network Error' || !error.response) {
      // Ağ hatası — üretimde sessizce logla, kullanıcıya teknik detay gösterme
      console.error('[API] Network error:', error.config?.url, error.message);
    }

    if (error.response && error.response.status === 401) {
      // Sadece token süresi dolduğunda çıkış yap, hatalı girişte değil
      if (error.config.url && !error.config.url.includes('/auth/login') && !error.config.url.includes('/auth/register')) {
        clearAuthToken();
        window.location.href = '#/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;